<template>
    <div class="add-to-wish-list-container">
        <div v-show='!on_wishlist && !product.on_wishlist' class="wishlist-icon" @click.stop.prevent='addToWishList'><i class="fa-regular fa-heart heart-icon"></i><span class="wishlist-text">Add to my wish list</span></div>
        <div v-show='on_wishlist || product.on_wishlist' class="wishlist-icon on-wishlist" @click.stop.prevent='removeFromWishList'><i class="fa-solid fa-heart heart-icon"></i><span class="wishlist-text">On your wish list</span></div>
    </div>
</template>

<script>
import Button from '@/ecom/components/buttons/Button.vue';
import {checkAuth, fireOmetriaCustomEvent} from "@/global/modules/functions.js";
export default {
    components:{Button},
    emits: ['removeFromWishListListener'],
    props: ['product'],
    data(){
        return{
            on_wishlist: false
        }
    },
    methods:{
        async checkWishList(){
            let response = await fetch(`/api/wishlist/check?product_id=${this.product.code}`, {
                method: 'GET',
                headers: {'Content-Type': 'application/json'},
            });

            let results = await checkAuth(response);
            
            if (response.status === 200){
               this.on_wishlist = results.on_wishlist;
            }
        },
        async addToWishList(){
            let response = await fetch(`/api/wishlist`, {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({
                    product_id: this.product.code,
                    product_name: this.product.productname
                }),    
            });

            let results = await checkAuth(response);
            
            if (response.status === 200){
                  if(!results.logged_in){
                    this.$router.push('/login');
                }
                else{
                    this.on_wishlist = true;
                    fireOmetriaCustomEvent('add_to_wishlist', this.product);
                }
            }
        },
        async removeFromWishList(){
            let response = await fetch(`/api/wishlist`, {
                method: 'DELETE',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({
                    product_id: this.product.code
                }),    
            });

            let results = await checkAuth(response);
            
            if (response.status === 200){
                if(!results.logged_in){
                    this.$router.push('/login');
                }
                else{
                    this.on_wishlist = false;
                    this.product.on_wishlist = false;
                    this.$emit('removeFromWishListListener', this.product.code);
                }
            }
        }
    },
    watch:{
        'product': function(){
            this.checkWishList();
        }
    }
}
</script>

<style lang="scss" scoped>
.add-to-wish-list-container{
    // margin-top: 30px;
    // position: relative;
    // left: -10px;
    // @media(max-width: 430px){
    //     left: 0px;
    // }
    // display: flex;
    // align-items: center;
    
}
.wishlist-icon{
    font-size: 1.3rem;
    cursor: pointer;
    pointer-events: auto;
    display: flex;
    gap: 0.5rem;
    // width:150px;
    color: var(--black);
    align-items: center;

    // @media(max-width: 1024px){
    //     font-size: 1.0rem;
    //     width:87px;
    // }
    // @media(max-width: 936px){
    //     font-size: 1.51rem;
    //     width: 150px;
    // }
    // @media(max-width: 414px){
    //     font-size: 1.0rem;
    //     width:93px;
    // }
    // @media(max-width: 344px){
    //     font-size: 1.0rem;
    //     width:75px;
    // }
}
.wishlist-text{
    font-size: 0.75rem;
    color: var(--black);
}
.on-wishlist{
    color:var(--yellow);
}
.heart-icon{
    // position: relative;
    // top: -4px;

    // @media(max-width: 1024px){
    //     top: 2px;
    // }
    // @media(max-width: 936px){
    //     top: -4px;
    // }
    // @media(max-width: 414px){
    //     top: 2px;
    // }
}
</style>